<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=4000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-container fluid class="mt-10">
            <div v-if="loading">
                <v-row>
                    <v-col>
                        <v-flex align-center>
                            <v-img max-width="700px" src="@/assets/loader.gif"></v-img>
                        </v-flex>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!loading && !unauthorized">
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-text>
                                <p class="display-1 text--primary">
                                    Hyundai Connect du {{ rdv.computed.date }} à {{ rdv.computed.heure }}
                                </p>
                                <v-row class="text-left">
                                    <v-col cols="4">
                                        Nom :
                                    </v-col>
                                    <v-col cols="8">
                                        {{ rdv.name }}
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="text-left">
                                    <v-col cols="4">
                                        Contacter par :
                                    </v-col>
                                    <v-col cols="8">
                                        {{ rdv.contactmethod }}
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="text-left">
                                    <v-col cols="4">
                                        GSM :
                                    </v-col>
                                    <v-col cols="8">
                                        {{ rdv.gsm }}
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="text-left">
                                    <v-col cols="4">
                                        Mail :
                                    </v-col>
                                    <v-col cols="8">
                                        {{ rdv.mail }}
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <div v-if="rdv.skypeid != ''">
                                    <v-row class="text-left">
                                        <v-col cols="4">
                                            Mail :
                                        </v-col>
                                        <v-col cols="8">
                                            {{ rdv.mail }}
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                </div>
                            </v-card-text>
                        </v-card>

                    </v-col>
                    <v-col>
                        <v-card >
                            <v-card-text>
                                <p class="display-1 text--primary">
                                    Informations sur l'appel {{rdv.statusappel}}
                                </p>
                                <v-row class="text-left">
                                    <v-col cols="12" class="d-flex">
                                        <v-select
                                                :items="statusAppel"
                                                label="Statut de l'appel"
                                                outlined
                                                dense
                                                v-model="rdv.statusappel"
                                        ></v-select>
                                    </v-col>
                                </v-row>

                                <div v-if="rdv.statusappel == 'Effectué'">
                                    <v-row class="text-left">
                                        <v-col>
                                            <h2>Modèles présentés : </h2>
                                        </v-col>
                                    </v-row>
                                    <v-row class="text-left">
                                        <v-col cols="4" md="3" v-for="model in models" v-bind:key="model.name">
                                            <v-checkbox
                                                    v-model=model.selection
                                                    :label=model.name
                                                    dense
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select
                                                    :items="interetClient"
                                                    label="Intérêt du client"
                                                    outlined
                                                    dense
                                                    v-model="rdv.interetclient"
                                            ></v-select>
                                        </v-col>
                                        <v-col>
                                            <v-select
                                                    :items="budget"
                                                    label="Budget du client"
                                                    outlined
                                                    dense
                                                    v-model="rdv.budgetclient"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select
                                                    :items="typeAchat"
                                                    label="Type d'achat"
                                                    outlined
                                                    dense
                                                    v-model="rdv.typeachatclient"
                                            ></v-select>
                                        </v-col>
                                        <v-col>
                                            <v-select
                                                    :items="prochaineAction"
                                                    label="Prochaine action"
                                                    outlined
                                                    dense
                                                    v-model="rdv.prochaineactionclient"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row class="text-left">
                                        <v-col>
                                            <h2>Commentaire : </h2>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-textarea
                                                    outlined
                                                    label=""
                                                    value=""
                                                    v-model="rdv.commentaireclient"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-row>
                                    <v-col>
                                        <v-btn
                                                depressed
                                                color="primary"
                                                block
                                                @click="saveRetour()"
                                        >Enregistrer</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!loading && unauthorized">
                <v-row>
                    <v-col cols="6" offset="3">
                        <v-alert
                                border="top"
                                color="red lighten-2"
                                dark
                                type="error"
                        >
                        Oups ! Vous n'avez pas le droit de consulter ce rendez-vous !
                        </v-alert>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </v-app>
</template>

<script>

    import NProgress from "nprogress";

    export default {
        name: 'ViewConnect',
        data() {
            return {
                unauthorized: false,
                loading: false,
                snackbar: false,
                errorMsg: '',
                rdv: {},
                statusAppel: ['Ne répond pas','Annulé','Effectué','Reporté','Mauvais numéro'],
                interetClient: ['Acheteur','Curieux','Pas intéressé','Inconnu'],
                budget: [   '< 100.000 Dhs',
                            '< 150.000 Dhs',
                            '< 200.000 Dhs',
                            '< 250.000 Dhs',
                            '< 300.000 Dhs',
                            '< 350.000 Dhs',
                            '< 400.000 Dhs',
                            '< 450.000 Dhs',
                            '< 500.000 Dhs',
                            '> 500.000 Dhs'
                ],
                typeAchat: ['Comptant','Crédit'],
                prochaineAction: [
                            'Abandonner ce contact',
                            'Recontacter dans 1 semaine',
                            'Recontacter dans 2 semaines',
                            'Recontacter dans 1 mois',
                            'Organiser un test drive',
                            'Organiser un rendez-vous'
                ],
                models: [
                    {"name":"Grand i10","selection":false},
                    {"name":"i20","selection":false},
                    {"name":"i30","selection":false},
                    {"name":"New Accent","selection":false},
                    {"name":"Elantra","selection":false},
                    {"name":"Ioniq","selection":false},
                    {"name":"Creta","selection":false},
                    {"name":"Kona","selection":false},
                    {"name":"Tucson","selection":false},
                    {"name":"Santa Fe","selection":false},
                    {"name":"Autre","selection":false},
                ]
            }
        },
        computed: {
        },
        props: ['id'],
        methods: {
            getRdv(){
                NProgress.start()
                this.loading = true
                let params = {}

                params.action = 'viewRdv'
                params.id = this.id
                this.axios
                    .post(this.$store.state.rootUrl+'apiSales.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.data.error === true){
                            if(data.data.data == 'Unauthorized'){
                                this.unauthorized = true
                            }
                            // TODO : faire une snackbar
                            NProgress.done()
                            return false
                        }
                        this.rdv = data.data.data

                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            },
            init(){
                this.snackbar = false
                this.errorMsg =  ''

                this.getRdv()

            },
            saveRetour(){
                if(this.rdv.statusappel == ''){
                    this.errorMsg = 'Veuillez sélectionner un status pour votre appel'
                    this.snackbar = true
                    return false
                }
                if(!confirm('Etes vous sûr de vouloir valider cet appel ?')){
                    return false
                }
                this.rdv.models = this.models

                NProgress.start()
                this.loading = true
                let params = {}

                params.action = 'saveRdv'
                params.rdv = this.rdv
                this.axios
                    .post(this.$store.state.rootUrl+'apiSales.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.data.error === true){
                            this.errorMsg = data.data.data
                            this.snackbar = true
                            NProgress.done()
                            return false
                        }


                        NProgress.done()
                        this.$router.push('/ListeConnect')
                    })
                    .catch( () => {
                        this.errorMsg = 'Impossible de contacter le serveur ! Veuillez réessayer dans quelques instants'
                        this.snackbar = true
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            }
        },
        mounted: function () {
            this.init()
        }
    }
</script>
